/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Save_Project_Cancelled_ErrorInputs */



/**
* | output |
* | --- |
* | "Save process cancelled by user" |
*
* @param {Shortcut_Keys_Save_Project_Cancelled_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_save_project_cancelled_error = /** @type {((inputs?: Shortcut_Keys_Save_Project_Cancelled_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Save_Project_Cancelled_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Processus d'enregistrement annule par l'utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichervorgang vom Benutzer abgebrochen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio del processo annullato dall'utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Процесс сохранения отменен пользователем")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proceso de guardado cancelado por el usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户取消了保存过程")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存プロセスはユーザーによってキャンセルされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता द्वारा सेव प्रक्रिया रद्द कर दी गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O processo de salvamento foi cancelado pelo usuário.")
	return /** @type {LocalizedString} */ ("Save process cancelled by user")
});